/*
  Collabs & Art Programs page behaviour.

  1. Measures the theme header and exposes it as --collabs-header-h so
     the sticky bar parks underneath it instead of under the viewport
     top. The header's height differs between desktop and mobile and
     changes on resize, so it is measured rather than hardcoded.
  2. Highlights the artist name whose chapter is in view.
  3. Scrolls that name into view inside the mobile scroller using
     scrollLeft. scrollIntoView is deliberately avoided: it also
     scrolls the page vertically, which fights the user.

  The segment filter is server-side and needs no JS.
*/
(function () {
  'use strict';

  var bar = document.querySelector('[data-collabs-bar]');
  if (!bar) return;

  var moreBtn = document.querySelector('[data-collabs-archive-more]');
  var archiveList = document.querySelector('[data-collabs-archive]');
  if (moreBtn && archiveList) {
    moreBtn.addEventListener('click', function () {
      archiveList.classList.add('is-expanded');
      moreBtn.remove();
    });
  }

  /* ---- 1. header height ---- */
  /* #HeaderWrapper is this theme's header element, inside
     .header-sticky-wrapper. Verified in sections/header.liquid:144. */
  function measureHeader() {
    var header = document.querySelector('#HeaderWrapper');
    var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--collabs-header-h', h + 'px');
  }
  measureHeader();
  window.addEventListener('resize', measureHeader);

  /* ---- 2 + 3. active chapter ---- */
  var chapters = [].slice.call(document.querySelectorAll('[data-collabs-chapter]'));
  var names = [].slice.call(document.querySelectorAll('[data-collabs-name]'));
  var scroller = document.querySelector('[data-collabs-names]');
  if (!chapters.length || !names.length) return;

  function setActive(handle) {
    names.forEach(function (link) {
      var on = link.getAttribute('data-collabs-name') === handle;
      link.classList.toggle('is-active', on);
      if (on && scroller && scroller.scrollWidth > scroller.clientWidth) {
        var target = link.offsetLeft - (scroller.clientWidth - link.offsetWidth) / 2;
        scroller.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        setActive(entry.target.getAttribute('data-collabs-chapter'));
      }
    });
  }, { threshold: 0.4 });

  chapters.forEach(function (chapter) { observer.observe(chapter); });

  /* ---- smooth scroll with the bar offset ---- */
  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var link = e.target.closest('[data-collabs-name], .collabs-names__more');
    if (!link) return;
    var hash = link.getAttribute('href');
    if (!hash || hash.charAt(0) !== '#') return;
    var target = document.querySelector(hash);
    if (!target) return;
    e.preventDefault();
    var header = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--collabs-header-h'), 10
    ) || 0;
    var offset = header + bar.getBoundingClientRect().height;
    window.scrollTo({
      top: window.pageYOffset + target.getBoundingClientRect().top - offset,
      behavior: 'smooth'
    });
  });
})();
